export default __webpack_public_path__ + "static/media/elite.b4e24f2c.svg";